<template>
    <span v-if="roleCode" :class="['user-role-badge', `user-role-badge--${roleCode}`]">
        {{ displayRoleName }}
    </span>
    <span v-else class="user-role-badge user-role-badge--empty">—</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    roleCode: {
        type: String,
        default: null
    },
    roleName: {
        type: String,
        default: null
    },
    hideUserPrefix: {
        type: Boolean,
        default: false
    }
})

const displayRoleName = computed(() => {
    if (!props.roleName) return ''
    let name = props.roleName.replace(/^Пользователь\s+/i, 'User ')
    // Если hideUserPrefix = true, убираем "User " из начала
    if (props.hideUserPrefix && name.startsWith('User ')) {
        name = name.substring(5) // Убираем "User "
    }
    return name
})
</script>

<style scoped lang="scss">
.user-role-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.625rem;
    border-radius: 0.375rem;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.2;
    white-space: nowrap;
    transition: all 0.2s ease;

    &--user_pro {
        background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
        color: #065f46;
        border: 1px solid rgba(5, 95, 70, 0.1);
        box-shadow: 0 1px 2px rgba(5, 95, 70, 0.05);
    }

    &--user_standard {
        background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
        color: #92400e;
        border: 1px solid rgba(146, 64, 14, 0.1);
        box-shadow: 0 1px 2px rgba(146, 64, 14, 0.05);
    }

    &--admin {
        background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
        color: #991b1b;
        border: 1px solid rgba(153, 27, 27, 0.1);
        box-shadow: 0 1px 2px rgba(153, 27, 27, 0.05);
    }

    &--agency {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #1e40af;
        border: 1px solid rgba(30, 64, 175, 0.1);
        box-shadow: 0 1px 2px rgba(30, 64, 175, 0.05);
    }

    &--empty {
        color: #9ca3af;
        font-style: italic;
    }
}
</style>
